import { QElement } from "./QElement";

export class QPanelDragger extends QElement {
  constructor() {
    super();
    this.fParentPanel = null;
    this.fStartX = 0;
    this.fStartY = 0;

    this.fOrigX = 0;
    this.fOrigY = 0;

    this.fAssociatedPanels = null;
  }

  InitPanelDragger(parentPanel) {
    this.fAssociatedPanels = [];
    this.fParentPanel = parentPanel;
    this.SetIsControl(true);
    this.SetGenerateInteractiveCmd(true);
  }

  AlternateStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    return false; // Override if needed
  }

  StartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    if (this.fParentPanel) {
      this.fStartX = canvasX;
      this.fStartY = canvasY;
      this.fOrigX = this.fParentPanel.GetPositionX();
      this.fOrigY = this.fParentPanel.GetPositionY();

      return true;
    } else {
      return this.AlternateStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown);
    }
  }

  InteractWithElement(x, y) {
    var sx = this.fParentPanel.GetPositionX();
    var sy = this.fParentPanel.GetPositionY();

    var deltaX = x + sx - this.fStartX;
    var deltaY = y + sy - this.fStartY;

    this.fParentPanel.PositionPanel(sx + deltaX, sy + deltaY);
    this.fStartX = x + sx;
    this.fStartY = y + sy;

    var n = this.fAssociatedPanels.length;
    for (var i = 0; i < n; i++) {
      var p = this.fAssociatedPanels[i];
      var subAssociates = [p];
      if (p.fPortPanel && !this.fAssociatedPanels.includes(p.fPortPanel))
        subAssociates.push(p.fPortPanel);
      for (var j in subAssociates) {
        var aPanel = subAssociates[j];
        this.ApplyInteractionDelta(aPanel, deltaX, deltaY);
      }
    }
  }

  ApplyInteractionDelta(associatePanel, deltaX, deltaY) {
    var sx = associatePanel.GetPositionX();
    var sy = associatePanel.GetPositionY();
    associatePanel.PositionPanel(sx + deltaX, sy + deltaY);
  }

  DoRenderElement(drawBuffer) {
    // Override this
  }

  DoHandleMouseUp() {
    // Override this
  }

  AssociatePanel(aPanel) {
    this.fAssociatedPanels.push(aPanel);
  }
}
